import "./WedgeWireSpecifications.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import WedgeSpecsHero from "./sections/WedgeSpecsHero";
import PurchaseSpecifications from "./sections/PurchaseSpecifications";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function WedgeWireSpecificationsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="WedgeWireSpecifications" />
      <WedgeSpecsHero />
      <PurchaseSpecifications />
      <RelatedArticles />
      <QuoteBanner />
      <Footer />
    </div>;
}